var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-main",
    {
      staticClass: "admin-settings",
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("h1", { staticClass: "title" }, [_vm._v("Settings")]),
                  _c("k-actions", {
                    staticClass: "header-actions",
                    attrs: { actions: _vm.actions, icons: _vm.icons },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [{ name: "bar", rawName: "v-bar" }],
          staticClass: "main-content",
        },
        [
          _c("div", { staticClass: "inner" }, [
            _c(
              "section",
              _vm._l(_vm.settings, function (setting) {
                return _c(
                  setting.component || "f-" + setting.type,
                  _vm._b(
                    {
                      key: setting.name,
                      tag: "div",
                      staticClass: "setting",
                      attrs: { value: _vm.newSettings[setting.name] },
                      on: {
                        input: function ($event) {
                          return _vm.updateSetting($event, setting.name)
                        },
                      },
                    },
                    "div",
                    setting,
                    false
                  )
                )
              }),
              1
            ),
          ]),
        ]
      ),
      _c("k-actions", {
        staticClass: "footer-actions",
        attrs: { actions: _vm.actions, icons: _vm.icons, type: "icon-text" },
        on: { exec: _vm.doAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }